<template>
<div class="benutzerverwaltung container">
  <div class="row">
    <div class="col-12 text-left">
      <mdb-btn color="info" v-on:click="backToList()">Zurück</mdb-btn>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <h1>Benutzer:</h1>
    </div>
  </div>
  <div class="row mt-5" v-if="type == 1">
    <div class="info col-12">
      <h4 class="info__item text-left mb-3">Letzter Login: {{user.logintime | date("DD.M.YYYY")}}</h4>
      <h4 class="info__item text-left mb-3 login__history" v-show="logins.length > 0" v-on:click="showLogins = !showLogins">Loginverlauf ansehen</h4>
      <h4 class="info__item text-left mb-3">Account erstellt am: {{user.creationdate | date("DD.M.YYYY")}}</h4>
      <div class="card card-cascade cascading-admin-card user-card my-5">

        <div class="admin-up d-flex justify-content-start p-3">
          <h1 class="font-weight-bold mb-0">{{$t('Global.Profil')}}</h1>
        </div>
        <div class="card-body card-body-cascade">

          <div class="row">
            <div class="col-12 col-md-4 text-left">
              <mdb-select v-model="status" @change="changeStatus($event)" :label="$t('Mieter.Status')" :placholder="$t('Global.Auswahlen')"></mdb-select>
            </div>
            <div class="col-12 col-md-4 text-left">
              <mdb-select v-model="institution" @change="changeInstitut($event)" :label="$t('Mieter.Institution')" :placholder="$t('Global.Auswahlen')"></mdb-select>
            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Mieter.Institutiongruppe')" v-model="user.institutionuntergruppe" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Mieter.Vorname')" v-model="user.vorname" />

            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Mieter.Nachname')" v-model="user.nachname" />
            </div>
            <div class="col-12 col-md-4">
              <mdb-select v-model="country" @change="changeCountry($event)" :label="$t('Mieter.Nationalitaet')" :placholder="$t('Global.Auswahlen')" ></mdb-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <mdb-date-picker v-model="user.aufenthaltvon" :option="option" :label="$t('Mieter.Aufenhaltvon')"/>

            </div>
            <div class="col-12 col-md-4">
              <mdb-date-picker v-model="user.aufenthaltbis" :option="option" :label="$t('Mieter.Aufenhaltbis')"/>

            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Mieter.Sonstiges')" v-model="user.sonstiges" />
            </div>

          </div>
          <div class="row  my-3">

            <div class="col-12 col-md-4">
              <div class="text-left">
                <label>{{$t('Mieter.Geschlecht')}}</label>
                <mdb-input type="radio" id="geschlecht-1" name="geschlecht" radioValue="w" v-model="user.geschlecht" :label="$t('Mieter.Weiblich')" />
                <mdb-input type="radio" id="geschlecht-2" name="geschlecht" radioValue="m" v-model="user.geschlecht" :label="$t('Mieter.Maenlich')" />

              </div>
            </div>
            <div class="col-12 col-md-4   mt-3 mt-md-0">
              <div class="text-left">
                <label> {{$t('Mieter.Familie')}}</label>
                <mdb-input type="radio" id="familie-1" name="familie" radioValue="1" v-model="user.mitfamilie" :label="$t('Global.Ja')" />
                <mdb-input type="radio" id="familie-2" name="familie" radioValue="0" v-model="user.mitfamilie" :label="$t('Global.Nein')" />

              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-12 col-md-4 ">
              <mdb-input :label="$t('Mieter.Email')" v-model="user.accountidentifier" />
            </div>
            <div class="col-12 col-md-4 ">
              <mdb-input type="password" :label="$t('Mieter.Password')" v-model="newPassword" autocomplete="off" />
            </div>
            <div class="col-12 col-md-4 ">
              <mdb-input type="password" :label="$t('Mieter.Passwordconfirm')" v-model="newPasswordvalid" autocomplete="off" />
            </div>


          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <mdb-btn color="danger" v-on:click="confirmDelete()">{{$t('Global.Deleteaccount')}}</mdb-btn>
                <mdb-btn color="primary"  @click.native.prevent="saveUserSuchend()">{{$t('Global.Speichern')}}</mdb-btn>

              </div>
            </div>
          </div>
        </div>
        <!-- Card content -->

      </div>


    </div>
  </div>
  <div class="row mt-5" v-if="type == 2">
    <div class="info col-12">
      <h4 class="info__item text-left mb-3">Letzter Login: {{user.logintime | date("DD.M.YYYY")}}</h4>
      <h4 class="info__item text-left mb-3 cursor-pointer login__history" v-show="logins.length > 0"  v-on:click="showLogins = !showLogins">Loginverlauf ansehen</h4>
      <h4 class="info__item text-left mb-3">Account erstellt am: {{user.creationdate | date("DD.M.YYYY")}}</h4>
      <div class="card card-cascade cascading-admin-card user-card my-5">

        <!-- Card Data -->
        <div class="admin-up d-flex justify-content-start p-3">
          <h1 class="font-weight-bold mb-0">{{$t('Global.Profil')}}</h1>
        </div>
        <!-- Card Data -->

        <!-- Card content -->
        <div class="card-body card-body-cascade">


          <div class="row">
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Vorname')" v-model="user.vorname" />

            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Nachname')" v-model="user.nachname" />

            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Straße')" v-model="user.strasse" />
            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.PLZ')" v-model="user.plz" />

            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Stadt')" v-model="user.ort" />
            </div>

          </div>
          <div class="row ">
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Telefon')" v-model="user.telefon" />

            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Mobil')" v-model="user.mobil" />
            </div>
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Vermieter.Fax')" v-model="user.fax" />

            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <mdb-input :label="$t('Mieter.Email')" v-model="user.accountidentifier" />
            </div>
            <div class="col-12 col-md-4">
              <mdb-input type="password" :label="$t('Mieter.Password')" v-model="newPassword" autocomplete="off"/>
            </div>
            <div class="col-12 col-md-4">
              <mdb-input type="password" :label="$t('Mieter.Passwordconfirm')" v-model="newPasswordvalid" autocomplete="off"/>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-space-between flex-column flex-lg-row">
                <mdb-btn color="danger" v-on:click="confirmDelete()">{{$t('Global.Deleteaccount')}}</mdb-btn>
                <mdb-btn color="primary"  @click.native.prevent="saveUserVermieter()">{{$t('Global.Speichern')}}</mdb-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- Card content -->

      </div>

    </div>
  </div>
  <div class="row mt-5" v-if="type == 2">
    <div class="col-12 mb-5">
      <h1>Liste aller Angebote des Vermieters</h1>
    </div>
    <div class="col-12">
      <Angebot :Angebote="Angebote" :isAdminEdit="true" :adminEditFor="user" :isOnMerkliste="true"/>
    </div>
  </div>
  <div class="confirm__remove" v-bind:class="{active: confirm == true}">
    <div class="inner d-flex justify-content-center align-items-center flex-column">
      <h2 class="text-center">Sind Sie sicher, dass Sie Ihren Account löschen möchten?</h2>

      <div class="d-flex mt-5">
        <div class="btn btn-outline-danger" v-on:click="confirmRemove(true)">löschen</div>
        <div class="btn btn-outline-danger" v-on:click="confirmRemove(false)">abbrechen</div>
      </div>
    </div>
  </div>
  <mdb-modal :show="showLogins && logins.length > 0" @close="showLogins = false" size="xl" scrollable>
    <mdb-modal-header>
      <mdb-modal-title>Loginverlauf</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
    <ul class="login-list">
      <li v-for="(login, index) in logins">
        {{index + 1}}. {{login.logintime | date("DD.MM.YYYY - HH:mm:ss")}}
      </li>
    </ul>
    </mdb-modal-body>
  </mdb-modal>
</div>
</template>

<script>
import settings from '@/components/Settings.json';
import UserService from "@/services/UserService";
import Angebot from "@/components/angebot/vermieter/AngebotVermieter";
import AngebotService from "@/services/AngebotService";
export default {
  name: "Benutzerverwaltung",
  components: {
    Angebot,
  },
  props:{
    user: Object,
    type: Number
  },
  data(){
    return{
      Angebote: [],
      confirm: false,
      newPassword: "",
      newPasswordvalid: "",
      Texte: "",
      status: [],
      institution: [],
      logins: [],
      showLogins: false,
      option: {
        format: 'D.M.YYYY',
        week: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        month: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        buttons: {
          ok: 'Ok',
          cancel: 'Abbrechen',
          today: 'Heute',
          clear: 'Löschen'
        }
      },
      country: settings.Settings[1][this.$store.getters.lang][0].country,
    }
  },
  methods: {
    backToList() {
      this.$router.push({name: 'benutzerverwaltung'})
    },
    confirmDelete() {
      this.confirm = true;
    },
    confirmRemove(state) {
      if (state) {
        this.confirm = false;
        this.deleteUser();
      } else {
        this.confirm = false;
      }
    },
    deleteUser(){
      let _this = this;
      if(this.type === 2){
        UserService.deleteUserVermieter(this.user.account, this.user.persistence_object_identifier).then(response => {
          this.$notify.success({
            position: 'top right',
            message: 'Benutzer wurde gelöscht',
            timeout: 3000
          });
          _this.backToList();

        })
      } else {
        UserService.deleteUserMieter(this.user.account).then(response => {
          this.$notify.success({
            position: 'top right',
            message: 'Benutzer wurde gelöscht',
            timeout: 3000
          });
          _this.backToList();

        })
      }
    },
    saveUserSuchend(){
      if(this.newPassword != ""){
        if( this.newPassword === this.newPasswordvalid){
          this.user.credentialssource = this.newPassword;
          this.user.aufenthaltvon = this.$func.formateDateForDB(this.user.aufenthaltvon);
          this.user.aufenthaltbis = this.$func.formateDateForDB(this.user.aufenthaltbis);


          UserService.editUserSuchender(this.user).then(response => {
            this.user.aufenthaltvon = this.$func.formateDateFromDB(this.user.aufenthaltvon);
            this.user.aufenthaltbis = this.$func.formateDateFromDB(this.user.aufenthaltbis);
            this.$notify.success({
              message: "Ihr Account wurde aktualisiert!",
              position: 'top right',
              timeOut: 4000
            });
          })
              .catch(e => {
                this.$notify.warn({
                  message: "Ihr Account konnte nicht aktualisiert werden!",
                  position: 'top right',
                  timeOut: 4000
                });
                console.log(e);

              });
        } else {
          this.$notify.error({
            message: "Passwörter stimmen nicht überein!",
            position: 'top right',
            timeOut: 4000
          });
        }
      } else {
        this.user.aufenthaltvon = this.$func.formateDateForDB(this.user.aufenthaltvon);
        this.user.aufenthaltbis = this.$func.formateDateForDB(this.user.aufenthaltbis);
        UserService.editUserSuchender(this.user).then(response => {
          this.$notify.success({
            message: "Ihr Account wurde aktualisiert!",
            position: 'top right',
            timeOut: 4000
          });
          this.user.aufenthaltvon = this.$func.formateDateFromDB(this.user.aufenthaltvon);
          this.user.aufenthaltbis = this.$func.formateDateFromDB(this.user.aufenthaltbis);
        })
            .catch(e => {
              this.$notify.warn({
                message: "Ihr Account konnte nicht aktualisiert werden!",
                position: 'top right',
                timeOut: 4000
              });
              console.log(e);

            });
      }
    },
    changeStatus(event){
      this.user.status = event;
    },
    changeInstitut(event){
      this.user.institution = event;
    },
    changeCountry(event){
      this.user.nationalitaet = event;
    },
    selectStatus(key) {
      this.status.forEach(option => {
        if(option.value == key){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    selectInstitut(key) {

      this.institution.forEach(option => {
        if(option.value.toLowerCase() == key.toLowerCase()){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    selectCountry(key) {
      this.country.forEach(option => {
        if(option.value == key){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    getLoginAmount(){
      console.log(this.type)
      if(this.type == 1){
        UserService.getSuchendeLogins(this.user.email).then(response =>{
          this.logins = response.data;
        })
      } else {
        UserService.getVermieterLogins(this.user.email).then(response =>{
          this.logins = response.data;
        })
      }

    },
    saveUserVermieter(){
      if(this.newPassword != ""){
        if( this.newPassword === this.newPasswordvalid){
          this.user.credentialssource = this.newPassword;

          UserService.editUserVermieter(this.user).then(response => {

            this.$notify.success({
              message: "Ihr Account wurde aktualisiert!",
              position: 'top right',
              timeOut: 4000
            });
          })
              .catch(e => {
                this.$notify.warn({
                  message: "Ihr Account konnte nicht aktualisiert werden!",
                  position: 'top right',
                  timeOut: 4000
                });
                console.log(e);

              });

        } else {
          this.$notify.error({
            message: "Passwörter stimmen nicht überein!",
            position: 'top right',
            timeOut: 4000
          });
        }
      } else {
        UserService.editUserVermieter(this.user).then(response => {
          this.$notify.success({
            message: "Ihr Account wurde aktualisiert!",
            position: 'top right',
            timeOut: 4000
          });
        })
            .catch(e => {
              this.$notify.warn({
                message: "Ihr Account konnte nicht aktualisiert werden!",
                position: 'top right',
                timeOut: 4000
              });
              console.log(e);

            });
      }
    }
  },
  mounted() {
    this.getLoginAmount();
    AngebotService.getAngeboteSelf(this.user.account)
        .then(response => {
          this.Angebote = response.data;
        })
        .catch(error => {
          console.log("There was an error:", error.response);
        });


    this.status = settings.Settings[1][this.$store.getters.lang][0].Bevorzugte;
    this.institution = settings.Settings[1][this.$store.getters.lang][0].Institution;
    this.selectStatus(this.user.status.toLowerCase());
    this.selectInstitut(this.user.institution.toLowerCase());
    this.selectCountry(this.user.nationalitaet);

    if(!this.$func.hasFrontendFormat(this.user.aufenthaltvon)){
      this.user.aufenthaltvon = this.$func.formateDateFromDB(this.user.aufenthaltvon);
      this.user.aufenthaltbis = this.$func.formateDateFromDB(this.user.aufenthaltbis);
    }

    if(this.user.mitfamilie == "ja" || this.user.mitfamilie == "Ja"){
      this.user.mitfamilie = "1";
    } else if(this.user.mitfamilie == "nein" || this.user.mitfamilie == "Nein"){
      this.user.mitfamilie = "0";
    }


  }
}
</script>

<style scoped>
.entry--item td{
  vertical-align: middle;
}
.pagination{
  display: flex;
  justify-content:  space-between;
}
.pagination__btn{
  cursor: pointer;
  font-weight: bold;
}
.login__history{
  cursor: pointer;
  color:  #c1002a;
  margin-bottom: 50px !important;
  display: block;
  font-weight: bold;
}
.login-list{
  list-style: none;
}
.login-list li {
  font-size: 20px;
  margin-bottom: 5px;
}
</style>